 
import CONQUER from "../../CONQUER";
import { ACTIONS } from "../../../Models/ENUM";
import InventoryItem from "./InventoryItem";
import ARRAY from "../../../UTIL/ARRAY";
import GameInstance from "../GameInstance";
import ShopItem from "../SHOP/ShopItem";
import LOG, { log } from "../../../UTIL/LOG";
import InventoryTab from "./InventoryTab";
import RANDOM from "../../../UTIL/RANDOM";
 
class PlayerInventory
{
    private conquer     : CONQUER;
 
    public items        : any;
    public tabs         : any;
    public selected     : any;
    private idKey       : string = "$i_";

    public gameInstance : GameInstance;

    private rarity      : any = {};

    constructor( gameInstance:GameInstance )
    {
        this.conquer        = gameInstance.conquer;
        this.gameInstance   = gameInstance;
        
    }

    public get( force?:boolean )
    {
        if( this.items && !force ) return this.items;

        this.items      = {};
        this.tabs       = {};
        this.selected   = {};

        // RELOAD

        let data : any  = ARRAY.searchObject( this.gameInstance.Data.data, this.idKey );
        for( let varName in data ) this.push( data[ varName ] );

        // CREATE

        let shopItems   = this.gameInstance.Shop.items;

        for ( let key in shopItems )
        {
            let shopItem = shopItems[ key ];

            if( shopItem.type != "Inventory" || this.items[ key ] ) continue;

            let vars  = {
                inventoryID : this.idKey + key,
                key         : key,
                isLocked    : !shopItem.data.autoEquip
            };

            this.push( vars );

            this.gameInstance.Data.display( vars.inventoryID, vars );
        }
 
        for( let n in this.tabs ) this.tabs[n].checkSelect();
 
        //log( "PlayerInventory Tabs", this.tabs );
       // log( "PlayerInventory Items", this.items );

        //log("GOT INVENTORY", this.selected );
 
        return this.items;
    }

    private push( itemData:any )
    {
        let items   = this.items;
        let tabs    = this.tabs;
 
        if( items[ itemData.key ] ) return;

        if( !this.gameInstance.Shop.items[ itemData.key ] )
        {
            // delete inventory from data
            return;
        }

        let item : InventoryItem = new InventoryItem( this.gameInstance, itemData );
        items[ item.key ] = item;

        // Rarity

        if( !this.rarity[ item.data.rarity ] ) this.rarity[ item.data.rarity ] = [];
        this.rarity[ item.data.rarity ].push( item );

        // Tabs

        let tabKey = item.tabKey;

        if( !tabs[ tabKey ] ) tabs[ tabKey ] = new InventoryTab( this, tabKey );
        tabs[ tabKey ].push( item );
 
        return item;
    }

    public getItem( key?:string )
    {
        return this.items[ key || "" ];
    };

    public reset()
    {
        // replace with a backend function to remove them all at once
        for( let key in this.items ) this.remove( this.items[ key ] );
    }

    public remove( inventoryItem:InventoryItem )
    {
        delete this.items[ inventoryItem.key ];
        this.tabs[ inventoryItem.data.tabKey ].remove( inventoryItem );
    }
 
    public setLoot( data:any )
    {
        let items       : any = [];
        let names       : any = [ "Common", "Rare", "Epic", "Legendary", "Mythic" ];
        let self        = this;

        for( let n in data.shopItems )
        {
            let shopItem : ShopItem = this.gameInstance.Shop.items[ data.shopItems[n] ];
            if( !shopItem ) continue;
            shopItem.set( true );
            items.push( shopItem );
        }

        for( let n=0; n<= data.guaranteed.length; n++ ) 
        {
            let amount = data.guaranteed[ n ];
            if( amount <= 0 ) continue;
            for( let i =0; i<amount; i++ ) pushCard( n );
        }

        while( items.length < data.cards ) pushCard( getOdds() );
    
        function getOdds() : number
        {
            for( var n=0; n< data.odds.length; n++ )
            {
                let random = RANDOM.decimal() * 100;
                let myOdds = data.odds[ n ];
                if( random < myOdds ) return n;
            }
            return getOdds();          
        }

        function pushCard( n:number )
        {
            let item : InventoryItem = self.getRarity( names[n] );

            if( !item ) return;

            item.shopItem.set( true );
 
            items.push( self.gameInstance.Shop.items[ item.key ] );
        }
 
        return items;
    }

    public getRarity( rarityName:string ) : InventoryItem
    {
        let array : any = ARRAY.shuffle( this.rarity[ rarityName ] || [] );
 
        for( let n in array )
        {
            let item : InventoryItem = array[n];
            if( !item.shopItem.isMaxxed ) return item;
        }

        return ARRAY.getRandomItem( array );
    }
}

export default PlayerInventory;